import { render, staticRenderFns } from "./SystemUserDetails.vue?vue&type=template&id=ced9f966&"
import script from "./SystemUserDetails.vue?vue&type=script&lang=js&"
export * from "./SystemUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports